export default __webpack_public_path__ + "images/usdt_5e33e1.svg";